import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { get } from '@/shared/api/client';
import s from '@/app/layouts/AppShell.module.css';

export const unreadKey = ['notifications', 'unread'] as const;

export function NotificationBell() {
  const { data } = useQuery({ queryKey: unreadKey, queryFn: () => get<{ unread: number }>('/notifications/unread-count'), refetchInterval: 60_000 });
  const n = data?.unread ?? 0;
  return (
    <Link to="/notificaciones" className={s.iconBtn} aria-label={n > 0 ? `Notificaciones: ${n} sin leer` : 'Notificaciones'}>
      <span aria-hidden="true">🔔</span>
      {n > 0 && <span className={s.dot}>{n > 99 ? '99+' : n}</span>}
    </Link>
  );
}
